import React, { useState, useEffect } from "react";
import { FormControl, FormHelperText, InputLabel } from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import AddCircleIcon from "@mui/icons-material/AddCircle";
import Button from "@mui/material/Button";
import Stack from "@mui/material/Stack";
import Grid from "@mui/material/Grid";
import Link from "@mui/material/Link";
import Breadcrumbs from "@mui/material/Breadcrumbs";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import Box from "@mui/material/Box";
import AppBar from "@mui/material/AppBar";
import { MenuItem, Autocomplete } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import TextField from "@mui/material/TextField";
import Alert from "@mui/material/Alert";
import Slide from "@mui/material/Slide";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import Snackbar from "@mui/material/Snackbar";
import CircularProgress from "@mui/material/CircularProgress";
import BorderColorOutlinedIcon from "@mui/icons-material/BorderColorOutlined";
import {
  externalpostApi,
  externalgetApi,
  externalImagepostApi,
} from "../../services/external/externalApis";

import { useNavigate, useLocation } from "react-router-dom";
import { useStyles } from "../../assets/styles/Theme";
import Navbar from "../../components/common/Navbar";
import AddToolbar from "../../components/common/AddToolbar";
import { useSelector } from "react-redux";
import TimezoneSelect from "react-timezone-select";
import {
  LOCATION_API_02,
  COUNTRY_API,
  CURRENCY_API,
  LOCATION_API_01,
  FILE_API_01,
} from "../../api/ApiModel";
import axios from "axios";
import { CON_STATUS_ACTIVE } from "../../utils/sys/Constants";
import { IMAGEBASEURL } from "../../api/EndPoints";
function AddLocations() {
  const [errors, setErrors] = useState({});
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [openErrorSnackbar, setOpenErrorSnackbar] = useState(false);
  const [error, setError] = useState(null);
  const [data, setData] = useState(null);
  const [dataloc, setDataloc] = useState(null);
  const [data2, setData2] = useState(null);
  const [imageSrc, setImageSrc] = useState(
    "https://st3.depositphotos.com/3326513/19442/v/450/depositphotos_194428038-stock-illustration-black-linear-photo-camera-logo.jpg" // Default image URL
  );
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const navigate = useNavigate();
  const location = useLocation();
  const { state } = useLocation();
  const { selectedItem } = state || {};
  const theme = useTheme();
  const styles = useStyles(theme);
  const isEdit = location.state?.actionText === "Edit";
  const SYS_USER = useSelector((state) => state.user) || {};
  const { COMPCODE, GROUPCODE, RESTCODE, USERNAME } = SYS_USER.USER_PARAM || {};
  const [isLoading, setIsLoading] = useState(true);
  const [apiResponseMessage, setApiResponseMessage] = useState("");
  const [isFocused, setIsFocused] = useState(false);

 

  const [selectedItemDetails, setSelectedItemDetails] = useState({
    WEBSITE: "",
    LOCCODE: "",
    LOCATION: "",
    ADDRESS: "",
    LOCADDRESS1: "",
    LOCADDRESS2: "",
    LOCADDRESS3: "",
    LSCODE: "",
    HOTLINE: "",
    FAX: "",
    EMAIL: "",
    CONTATCPERSON: "",

    COUNTRYCODE: "",
    TIMEZONEINFO: "",
    PREFCURRENCYCODE: "",
  });

  useEffect(() => {
    if (selectedItem) {
      setSelectedItemDetails({
        WEBSITE: selectedItem.WEBSITE,

        LOCCODE: selectedItem.LOCCODE,

        LOCATION: selectedItem.LOCATION,
        ADDRESS: selectedItem.ADDRESS,
        LOCADDRESS1: selectedItem.LOCADDRESS1,
        LOCADDRESS2: selectedItem.LOCADDRESS2,
        LOCADDRESS3: selectedItem.LOCADDRESS3,
        LSCODE: selectedItem.LSCODE,
        HOTLINE: selectedItem.HOTLINE,
        FAX: selectedItem.FAX,
        EMAIL: selectedItem.EMAIL,
        CONTATCPERSON: selectedItem.CONTATCPERSON,
        COUNTRYCODE: selectedItem.COUNTRYCODE,
        TIMEZONEINFO: selectedItem.TIMEZONEINFO,
        PREFCURRENCYCODE: selectedItem.PREFCURRENCY,
      });
    }
  }, [selectedItem]);

  useEffect(() => {
    if (selectedItem && selectedItem.LOGO) {
      setImageSrc(selectedItem.LOGO);
      console.log("selectedItem.LOGO:", `${selectedItem.LOGO}`);
    }
  }, [selectedItem]);

  const selectedValue = selectedItemDetails.TIMEZONEINFO;

  useEffect(() => {
    const fetchData = async () => {
      try {
        const result = await externalgetApi(CURRENCY_API, "get");
        setData(result); // Update data with API response
      } catch (err) {
        setError(err); // Handle error
        console.error("Error fetching currencies:", err);
      }
    };

    fetchData();
  }, []);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const result = await externalgetApi(COUNTRY_API, "get");
        setData2(result); // Update data with API response
        console.log("currency", result);
      } catch (err) {
        setError(err); // Handle error
        console.error("Error fetching currencies:", err);
      }
    };

    fetchData();
  }, []);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    // Clear the error for the specific field when the user starts typing
    if (errors[name]) {
      setErrors((prevErrors) => ({ ...prevErrors, [name]: "" }));
    }

    setSelectedItemDetails({
      ...selectedItemDetails,
      [name]: value,
    });
    setError((prevError) => ({
      ...prevError,
      [name]: "",
    })); // Clear field-specific error on input
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const result = await externalgetApi(LOCATION_API_01, "get", {
          COMPCODE,
          GROUPCODE,
          USERNAME,

          STS: CON_STATUS_ACTIVE,
        });
        setDataloc(result);
      } catch (err) {
        console.error("Error fetching data:", err);
      } finally {
      }
    };

    fetchData();
  }, []);

  const handleConfirmClick = async () => {
    setImageSrc("");
    setFilePath("");
    const {
      WEBSITE,
      LOGO,
      LOCCODE,

      LOCATION,
      ADDRESS,
      LOCADDRESS1,
      LOCADDRESS2,
      LOCADDRESS3,
      LSCODE,
      HOTLINE,
      FAX,
      EMAIL,
      CONTATCPERSON,
      COUNTRYCODE,
      TIMEZONEINFO,
      PREFCURRENCYCODE,
    } = selectedItemDetails;

    const requiredFields = [
      { name: "LOCCODE", value: LOCCODE, label: "Location Code" },
      { name: "LOCATION", value: LOCATION, label: "Location" },

      { name: "LOCADDRESS1", value: LOCADDRESS1, label: "Location Address 1" },

      { name: "HOTLINE", value: HOTLINE, label: "Hotline" },

      { name: "EMAIL", value: EMAIL, label: "Email" },
      { name: "CONTATCPERSON", value: CONTATCPERSON, label: "Contact Person" },
      { name: "COUNTRYCODE", value: COUNTRYCODE, label: "Country " },
      { name: "TIMEZONEINFO", value: TIMEZONEINFO, label: "Timezone Info" },
      {
        name: "PREFCURRENCY",
        value: PREFCURRENCYCODE,
        label: "Preferred Currency ",
      },
    ];

    // Required field validation
    const missingRequiredFields = requiredFields.filter(
      (field) => !field.value
    );
    if (missingRequiredFields.length > 0) {
      const newError = {};
      missingRequiredFields.forEach((field) => {
        newError[field.name] = `${field.label} is required.`; // Set error message for each missing field
      });

      setErrors(newError); // Set the error state
      const missingFieldLabels = missingRequiredFields
        .map((field) => field.label)
        .join(", ");
      const errorMessage = `Required fields: ${missingFieldLabels}.`;

      setSnackbarMessage(errorMessage); // Show snackbar with missing fields
      setOpenErrorSnackbar(true);
      return; // Stop submission if there are validation errors
    }

    const validateEmail = (email) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
    if (!validateEmail(EMAIL)) {
      setErrors((prevErrors) => ({
        ...prevErrors,
        EMAIL: "Please enter a valid email address.",
      }));
      setSnackbarMessage("Please enter a valid email address.");
      setOpenErrorSnackbar(true);
      return; // Stop further execution if the email is invalid
    }

    const loccode = selectedItem ? String(selectedItem.LOCCODE || "") : "";

    const staticValues = {
      COMPCODE,
      BOOKINGKEY: "",

      LOGO: imageSrc,
      CITY: "",
      DISTRICT: "",
      ENUSER: USERNAME,
      SYSDATE: new Date().toISOString(),
      ismodify: isEdit ? true : false,
      LOCDATE: new Date().toISOString(),
      STS: CON_STATUS_ACTIVE,
    };

    const payload = {
      ...selectedItemDetails,
      ...staticValues,
      LOCCODE: loccode,
    };

    try {
      console.log("Payload for API call:", payload);
      const responseData = await externalpostApi(LOCATION_API_02, payload);
      console.log("Success:", responseData);

      // Check for any API response message
      if (responseData) {
        setApiResponseMessage(responseData); // Set API response message
      } else {
        setApiResponseMessage(""); // Clear message if none
      }
      setOpenSnackbar(true);

      if (responseData === true) {
        setTimeout(() => {
          navigate("/ViewLocations");
        }, 2000);
      }
      // setOpenSnackbar(true);
      setSelectedItemDetails({
        WEBSITE: "",
        LOCCODE: "",
        LOCATION: "",
        ADDRESS: "",
        LOCADDRESS1: "",
        LOCADDRESS2: "",
        LOCADDRESS3: "",
        LSCODE: "",
        HOTLINE: "",
        FAX: "",
        EMAIL: "",
        CONTATCPERSON: "",
        COUNTRYCODE: "",
        TIMEZONEINFO: "",
        PREFCURRENCYCODE: "",
      });
    } catch (error) {
      console.error("Error:", error);
      setError(error.message);
      setApiResponseMessage("");
      setOpenErrorSnackbar(true);
    }
  };

  const gotToPage = () => {
    navigate("/ViewLocations");
  };

  const handleSnackbarClose = () => {
    setOpenSnackbar(false);
  };

  const handleErrorSnackbarClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenErrorSnackbar(false); // Reset the snackbar state
  };

  const handleClearClick = () => {
    setSelectedItemDetails({
      WEBSITE: "",
      LOCCODE: "",
      LOCATION: "",
      ADDRESS: "",
      LOCADDRESS1: "",
      LOCADDRESS2: "",
      LOCADDRESS3: "",
      LSCODE: "",
      HOTLINE: "",
      FAX: "",
      EMAIL: "",
      CONTATCPERSON: "",
      COUNTRYCODE: "",
      TIMEZONEINFO: "",
      PREFCURRENCYCODE: "",
    });
  };

  const handleInputEmailValidation = (event) => {
    const { name, value } = event.target;
    const validateEmail = (email) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
    // Update userDetails state first
    handleInputChange(event);

    // Validate the email input
    if (value.trim() === "") {
      setErrors((prevErrors) => ({
        ...prevErrors,
        [name]: "Email is required.", // Optional: check for empty input
      }));
    } else if (validateEmail(value)) {
      setErrors((prevErrors) => ({ ...prevErrors, [name]: "" })); // Clear error on valid email
    } else {
      setErrors((prevErrors) => ({
        ...prevErrors,
        [name]: "Please enter a valid email address.", // Set error message for invalid email
      }));
    }
  };
  const handleInputWebsiteValidation = (event) => {
    const { name, value } = event.target;
    const validateWebsite = (website) =>
      /^(https?:\/\/)?([\w\d\-]+\.)+\w{2,}(\/.*)?$/.test(website);

    // Update userDetails state first
    handleInputChange(event);

    // Validate the website input
    if (value.trim() === "") {
      setErrors((prevErrors) => ({
        ...prevErrors,
        [name]: "Website is required.", // Optional: check for empty input
      }));
    } else if (validateWebsite(value)) {
      setErrors((prevErrors) => ({ ...prevErrors, [name]: "" })); // Clear error on valid website
    } else {
      setErrors((prevErrors) => ({
        ...prevErrors,
        [name]: "Invalid website URL.",
      }));
    }
  };
  const handleNumInputValidation = (event) => {
    const { name, value } = event.target;

    // Regular expression to allow only numbers and floats
    const regex = /^[0-9]*\.?[0-9]*$/;

    if (regex.test(value) && value.length <= 10) {
      // Valid input: matches regex and is within 10-character limit
      setErrors((prevErrors) => ({ ...prevErrors, [name]: "" })); // Clear error for this field
      setSelectedItemDetails((prevDetails) => ({
        ...prevDetails,
        [name]: value, // Update state with the valid input
      }));
    } else if (value.length > 10) {
      // Exceeds character limit
      setErrors((prevErrors) => ({
        ...prevErrors,
        [name]: "Contact cannot exceed 10 characters.",
      }));
    } else {
      // Invalid format
      setErrors((prevErrors) => ({
        ...prevErrors,
        [name]: "Only numbers and floats are allowed.",
      }));
    }
  };
  const [filePath, setFilePath] = useState("");

  const handleImageChange = async (event) => {
    const file = event.target.files[0];
    if (!file) {
      console.error("No file selected.");
      return;
    }

    const fileType = file.type;
    if (fileType !== "image/jpeg" && fileType !== "image/png") {
      console.error("Only JPG and PNG files are allowed.");
      return;
    }

    // Preview the selected image
    const reader = new FileReader();
    reader.onload = (e) => setImageSrc(e.target.result);
    reader.readAsDataURL(file);

    // Prepare the FormData
    const formData = new FormData();
    formData.append("file", file);
    formData.append("COMPCODE", COMPCODE);

    try {
      // Construct the API URL
      const apiUrl = `${FILE_API_01}?COMPCODE=${encodeURIComponent(COMPCODE)}`;
      console.log("Sending request to API:", apiUrl);

      // Send the file to the server
      const response = await externalImagepostApi(apiUrl, formData);

      // Log the complete response
      console.log("API Response:", response);

      // Safely extract and format the file path
      const { filePath } = response || {};
      if (filePath) {
        const formattedPath = filePath.replace(/\\/g, "/");
        const fullPath = `${IMAGEBASEURL}${formattedPath}`;
        setFilePath(fullPath);
        setImageSrc(fullPath);
        console.log("File uploaded successfully:", fullPath);
      } else {
        console.error("File path not found in API response.");
      }
    } catch (error) {
      console.error("Error uploading file:", error);

      if (error.response) {
        console.error("API Response Error Data:", error.response.data);
      } else {
        console.error("Network or other error:", error.message);
      }
    }
  };

  return (
    <div>
      <Navbar />
      <AppBar sx={styles.AI_CustomAppBar1}>
        <Box sx={styles.AI_HeaderContainer1}>
          <Grid container spacing={2}>
            <Grid item xs={12} md={6}>
              <Breadcrumbs
                sx={styles.AI_breadcrumbs2}
                position="fixed"
                separator={<NavigateNextIcon fontSize="small" />}
              >
                <Link underline="none">Home</Link>
                <Link underline="none">Location</Link>
                <Link underline="none">Add Location</Link>
              </Breadcrumbs>
            </Grid>
            <Grid item xs={12} md={6} p={2}>
              <Stack
                sx={{
                  ...styles.AI_fixedStack2,
                  direction: "row",
                  justifyContent: "flex-end",
                }}
              >
                <Button
                  onClick={gotToPage}
                  variant="contained"
                  startIcon={<ArrowBackIcon />}
                  sx={{
                    background: theme.palette.primary.main,
                    color: theme.palette.text.buttontxt,
                    textTransform: "capitalize",
                    letterSpacing: "1px",
                    width: "80px",
                  }}
                  id="btnback"
                >
                  Back
                </Button>
              </Stack>
            </Grid>
          </Grid>
        </Box>
      </AppBar>

      <Box sx={styles.AI_AddStyledBox}>
        <AddToolbar
          label={{
            name: isEdit ? " Edit Location Details" : "Add Location Details",
          }}
        />
        <Grid container spacing={2} sx={styles.AI_container}>
          <Grid item lg={6} md={6} xs={12} sm={12}>
            <TextField
              label={
                <span>
                  Location Code<span style={{ color: "red" }}> *</span>
                </span>
              }
              id="txtcompanycode"
              size="small"
              fullWidth
              variant="outlined"
              autoComplete="off"
              name="LOCCODE"
              value={selectedItemDetails.LOCCODE}
              onChange={handleInputChange}
              error={Boolean(errors.LOCCODE)}
              helperText={errors.LOCCODE}
              disabled={isEdit} // Disable when in edit mode
            />
          </Grid>
          <Grid item lg={6} md={6} xs={12} sm={12}>
            <TextField
              label={
                <span>
                  Hotline<span style={{ color: "red" }}> *</span>
                </span>
              }
              id="txthotline"
              size="small"
              fullWidth
              variant="outlined"
              autoComplete="off"
              name="HOTLINE"
              value={selectedItemDetails.HOTLINE}
              onChange={handleNumInputValidation}
              error={Boolean(errors.HOTLINE)}
              helperText={errors.HOTLINE}
            />
          </Grid>
          <Grid item lg={6} md={6} xs={12} sm={12}>
            <TextField
              label={
                <span>
                  Location/Entity <span style={{ color: "red" }}> *</span>
                </span>
              }
              id="txtcompanyname"
              size="small"
              fullWidth
              variant="outlined"
              autoComplete="off"
              name="LOCATION"
              value={selectedItemDetails.LOCATION}
              onChange={handleInputChange}
              error={Boolean(errors.LOCATION)}
              helperText={errors.LOCATION}
            />
          </Grid>
          <Grid item lg={6} md={6} xs={12} sm={12}>
            <TextField
              label="Fax"
              id="txtfax"
              size="small"
              fullWidth
              variant="outlined"
              autoComplete="off"
              name="FAX"
              value={selectedItemDetails.FAX}
              onChange={handleNumInputValidation}
              error={Boolean(errors.FAX)}
              helperText={errors.FAX}
            />
          </Grid>
          <Grid item lg={6} md={6} xs={12} sm={12}>
            <TextField
              label={
                <span>
                  Address Line 1<span style={{ color: "red" }}> *</span>
                </span>
              }
              id="txtaddress1"
              size="small"
              fullWidth
              variant="outlined"
              autoComplete="off"
              name="LOCADDRESS1"
              value={selectedItemDetails.LOCADDRESS1}
              onChange={handleInputChange}
              error={Boolean(errors.LOCADDRESS1)}
              helperText={errors.LOCADDRESS1}
            />
          </Grid>
          <Grid item lg={6} md={6} xs={12} sm={12}>
            <TextField
              label={
                <span>
                  Email<span style={{ color: "red" }}> *</span>
                </span>
              }
              id="txtemail"
              size="small"
              fullWidth
              variant="outlined"
              autoComplete="off"
              name="EMAIL"
              value={selectedItemDetails.EMAIL}
              onChange={handleInputEmailValidation}
              error={Boolean(errors.EMAIL)}
              helperText={errors.EMAIL}
              disabled={isEdit} // Disable when in edit mode
            />
          </Grid>

          <Grid item lg={6} md={6} xs={12} sm={12}>
            <TextField
              // label={
              //   <span>
              //     Address Line 2<span style={{ color: "red" }}> *</span>
              //   </span>
              // }
              label="Address Line 2"
              id="txtaddress2"
              size="small"
              fullWidth
              variant="outlined"
              autoComplete="off"
              name="LOCADDRESS2"
              value={selectedItemDetails.LOCADDRESS2}
              onChange={handleInputChange}
              error={Boolean(errors.LOCADDRESS2)}
              helperText={errors.LOCADDRESS2}
            />
          </Grid>
          <Grid item lg={6} md={6} xs={12} sm={12}>
            <TextField
              label="Website"
              id="txtwebsite"
              size="small"
              fullWidth
              variant="outlined"
              autoComplete="off"
              name="WEBSITE"
              value={selectedItemDetails.WEBSITE}
              onChange={handleInputWebsiteValidation}
              error={Boolean(errors.WEBSITE)}
              helperText={errors.WEBSITE}
            />
          </Grid>
          <Grid item lg={6} md={6} xs={12} sm={12}>
            <TextField
              label="Address Line 3"
              id="txtaddress3"
              size="small"
              fullWidth
              variant="outlined"
              autoComplete="off"
              name="LOCADDRESS3"
              value={selectedItemDetails.LOCADDRESS3}
              onChange={handleInputChange}
              error={Boolean(errors.LOCADDRESS3)}
              helperText={errors.LOCADDRESS3}
            />
          </Grid>

          <Grid item lg={6} md={6} xs={12} sm={12}>
            <TextField
              label={
                <span>
                  Contact Person<span style={{ color: "red" }}> *</span>
                </span>
              }
              id="txtcontactperson"
              size="small"
              fullWidth
              variant="outlined"
              autoComplete="off"
              name="CONTATCPERSON"
              value={selectedItemDetails.CONTATCPERSON}
              onChange={handleInputChange}
              error={Boolean(errors.CONTATCPERSON)}
              helperText={errors.CONTATCPERSON}
            />
          </Grid>
          <Grid item lg={6} md={6} xs={12} sm={12}>
            <Autocomplete
              value={
                // Check if data2 is an array and if selectedItemDetails has COUNTRYCODE
                selectedItemDetails.PREFCURRENCYCODE
                  ? (Array.isArray(data) &&
                      data.find(
                        (item) =>
                          item.CURRENCYCODE ===
                          selectedItemDetails.PREFCURRENCYCODE
                      )) ||
                    null
                  : null
              }
              onChange={(event, newValue) => {
                // Handle change and set COUNTRYCODE when an option is selected
                handleInputChange({
                  target: {
                    name: "PREFCURRENCYCODE", // Set COUNTRYCODE here
                    value: newValue ? newValue.CURRENCYCODE : "", // Set COUNTRYCODE if newValue exists
                  },
                });

                // Additional logic for setting MEMBERSHIPCODE if needed
              }}
              options={data}
              getOptionLabel={(option) => option.CURRENCY || ""}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label={
                    <span>
                      Default Currency <span style={{ color: "red" }}> *</span>
                    </span>
                  }
                  variant="outlined"
                  size="small"
                  fullWidth
                  error={Boolean(errors.PREFCURRENCY)}
                  helperText={errors.PREFCURRENCY}
                />
              )}
              ListboxProps={{
                style: {
                  maxHeight: 150,
                  backgroundColor: theme.palette.background.paper, // Apply theme background
                },
              }}
            />
          </Grid>
          <Grid item lg={6} md={6} xs={12} sm={12}>
            <FormControl fullWidth error={Boolean(errors.TIMEZONEINFO)}>
              {/* Input Label with conditional styling */}
              <InputLabel
                shrink={Boolean(isFocused || selectedValue)}
                sx={{
                  position: "absolute",
                  top: isFocused || selectedValue ? -8 : "50%",
                  left: 14,
                  transform:
                    isFocused || selectedValue
                      ? "translateY(0)"
                      : "translateY(-50%)",
                  transition: "all 0.2s ease-out",
                  backgroundColor: theme.palette.background.paper,
                  px: 0.5,
                  fontSize: isFocused || selectedValue ? 12 : 16,
                 
                }}
              >
                Timezone <span style={{ color: "red" }}>*</span>
              </InputLabel>

              <TimezoneSelect
                styles={{
                  control: (base, state) => ({
                    ...base,
                    borderColor: errors.TIMEZONEINFO
                      ? "red"
                      : theme.palette.divider,
                    color: theme.palette.text.primary,
                    backgroundColor: theme.palette.background.paper,
                    "&:hover": {
                      borderColor: errors.TIMEZONEINFO
                        ? "red"
                        : theme.palette.primary.main,
                    },
                  }),
                  placeholder: (base) => ({
                    ...base,
                    color: theme.palette.text.secondary,
                  }),
                  menu: (base) => ({
                    ...base,
                    color: theme.palette.text.primary,
                    backgroundColor: theme.palette.background.paper,
                  }),
                  option: (base, state) => ({
                    ...base,
                    backgroundColor: state.isSelected
                      ? theme.palette.action.selected
                      : theme.palette.background.paper,
                    color: theme.palette.text.primary,
                    "&:hover": {
                      backgroundColor: theme.palette.action.hover,
                    },
                  }),
                  singleValue: (base) => ({
                    ...base,
                    color: theme.palette.text.primary, // Ensure selected value uses theme color
                  }),
                }}
                name="TIMEZONEINFO"
                value={
                  selectedValue
                    ? {
                        value: selectedValue,
                        label: selectedValue,
                      }
                    : null
                }
                placeholder=""
                onFocus={() => setIsFocused(true)}
                onBlur={() => setIsFocused(false)}
                onChange={(newValue) => {
                  handleInputChange({
                    target: {
                      name: "TIMEZONEINFO",
                      value: newValue ? newValue.value : "",
                    },
                  });
                }}
              />

              {errors.TIMEZONEINFO && (
                <FormHelperText sx={{ color: "red" }}>
                  {errors.TIMEZONEINFO}
                </FormHelperText>
              )}
            </FormControl>
          </Grid>

          <Grid item lg={6} md={6} xs={12} sm={12}>
            <Autocomplete
              value={
                selectedItemDetails.COUNTRYCODE
                  ? (Array.isArray(data2) &&
                      data2.find(
                        (item) =>
                          item.COUNTRYCODE === selectedItemDetails.COUNTRYCODE
                      )) ||
                    null
                  : null
              }
              options={data2 || []} // Ensure that options are an empty array if data2 is null or undefined
              getOptionLabel={(option) => option.COUNTRY || ""} // Show country name in the dropdown
              onChange={(event, newValue) => {
                // Handle change and set COUNTRYCODE when an option is selected
                handleInputChange({
                  target: {
                    name: "COUNTRYCODE", // Set COUNTRYCODE here
                    value: newValue ? newValue.COUNTRYCODE : "", // Set COUNTRYCODE if newValue exists
                  },
                });

                // Additional logic for setting MEMBERSHIPCODE if needed
              }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label={
                    <span>
                      Country <span style={{ color: "red" }}> *</span>
                    </span>
                  }
                  variant="outlined"
                  size="small"
                  fullWidth
                  error={Boolean(errors.COUNTRYCODE)}
                  helperText={errors.COUNTRYCODE}
                />
              )}
              ListboxProps={{
                style: {
                  maxHeight: 150,
                  backgroundColor: theme.palette.background.paper, // Apply theme background
                },
              }}
            />
          </Grid>

          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              gap: "20px", // Space between the image and button
              padding: "20px",
            }}
          >
            {/* Image Preview */}
            <Box>
              {/* Image Display Box */}
              <Box
                sx={{
                  width: 150,
                  height: 150,
                  border: "1px solid #ccc",
                  borderRadius: 1,
                  overflow: "hidden",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  backgroundColor: "#f9f9f9",
                  flexShrink: 0,
                }}
              >
                {imageSrc || selectedItemDetails?.LOGO ? (
                  <img
                    src={imageSrc || `${selectedItemDetails.LOGO}`} // Use filePath or fallback to LOGO
                    alt="Selected"
                    style={{
                      width: "100%",
                      height: "100%",
                      objectFit: "cover",
                      display: "block",
                    }}
                  />
                ) : (
                  <Box
                    sx={{
                      fontSize: 14,
                      color: "#888",
                      textAlign: "center",
                    }}
                  >
                    No Image Selected
                  </Box>
                )}
              </Box>
            </Box>

            {/* Upload Button */}
            <Button
              component="label"
              variant="contained"
              startIcon={<CloudUploadIcon />}
            >
              Upload Image
              <input
                type="file"
                accept="image/*"
                hidden
                onChange={handleImageChange}
              />
            </Button>
          </Box>
        </Grid>
        <Stack
          direction="row"
          spacing={2}
          m={1}
          justifyContent="flex-end"
          padding={1}
        >
          <Button
            variant="outlined"
            sx={styles.AI_button1}
            onClick={handleClearClick}
            id="btnclr"
          >
            Clear
          </Button>
          <Button
            variant="contained"
            sx={styles.AI_button2}
            onClick={handleConfirmClick}
            id="btnconfirm"
          >
            {isEdit ? "Modify" : "Confirm"}
          </Button>
        </Stack>

        <Snackbar
          open={openSnackbar}
          autoHideDuration={6000}
          onClose={handleSnackbarClose}
          anchorOrigin={{ vertical: "top", horizontal: "right" }}
          sx={{ top: "10%", right: "10%" }}
        >
          <Alert
            onClose={handleSnackbarClose}
            // severity={apiResponseMessage != "" ? "warning" : "success"}
            severity={apiResponseMessage === true ? "success" : "warning"}
            sx={{ width: "100%" }}
          >
            {apiResponseMessage === true
              ? isEdit
                ? " Updated Successfully!"
                : " Created Successfully!"
              : apiResponseMessage}
          </Alert>
        </Snackbar>

        <Snackbar
          open={openErrorSnackbar}
          autoHideDuration={6000}
          onClose={handleErrorSnackbarClose}
          anchorOrigin={{ vertical: "top", horizontal: "right" }}
          sx={{ top: "10%", right: "10%" }}
        >
          <Alert
            onClose={handleErrorSnackbarClose}
            severity="error"
            sx={{ width: "100%" }}
          >
            {snackbarMessage}
          </Alert>
        </Snackbar>
      </Box>
    </div>
  );
}

export default AddLocations;
